import { FONT_SECONDARY } from "@/theme/typography"

export const popoverStyles = {
  zIndex: 10,
  display: { xs: "block", lg: "none" },
  backgroundColor: "white",
}

export const mobileMenuStyles = {
  sx: {
    left: "0 !important",
    height: "90%",
    maxWidth: "100%",
    border: "none",
    boxShadow: "none",
    width: "100%",
    boxSizing: "border-box",
    paddingY: 2,
    paddingX: 3,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: 2,
  },
}

export const mobileLinkStyles = {
  display: "flex",
  alignItems: "center",
  width: "100%",
  height: "100%",
  fontFamily: FONT_SECONDARY,
  fontWeight: 500,
  minHeight: "48px",
}

export const accordionStyles = {
  width: "100%",
  border: "none",
  boxShadow: "none",
  backgroundColor: 'transparent',
}

export const accordionSummaryStyles = {
  "& .MuiAccordionSummary-content": {
    margin: "0 !important",
  },
  paddingY: 1.5,
  padding: 0,
  width: "100%",
  "&:hover": { backgroundColor: "transparent", color: "primary.main" },
  "&:focus": { backgroundColor: "transparent", color: "primary.main" },
}